import React from "react";

const About = () => {
  const page = {
    backgroundColor: "#05070a",
    color: "#ffffff",
    minHeight: "100vh",
    paddingTop: "140px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    overflowX: "hidden",
  };

  const container = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  };

  const glass = {
    background: "rgba(255,255,255,0.02)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "24px",
    padding: "40px",
    backdropFilter: "blur(12px)",
  };

  const accentText = {
    color: "#00d4ff",
    letterSpacing: "4px",
    textTransform: "uppercase",
    marginBottom: "20px",
    fontWeight: "700",
    fontSize: "0.85rem"
  };

  return (
    <div style={page}>
      {/* ================= HERO SECTION ================= */}
      <section style={container}>
        <div style={{ textAlign: "center", marginBottom: "80px" }}>
          <h4 style={accentText}>INNOVATE • ELEVATE • ACCELERATE</h4>
          <h1 style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)", fontWeight: "900", lineHeight: "1.1", marginBottom: "30px", letterSpacing: "-1px" }}>
            The Force Behind <br />
            <span style={{ color: "#00d4ff" }}>Digital Transformation</span>
          </h1>
          <p style={{ fontSize: "1.15rem", color: "#a0aab4", maxWidth: "850px", margin: "0 auto 40px", lineHeight: "1.8" }}>
            Digital-X-AI is an innovative startup specializing in technology consultancy, 
            resource enablement, and technical mentorship. Our mission is to help businesses 
            build their digital presence and succeed in a competitive global market.
          </p>
        </div>

        {/* ================= OUR STORY ================= */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))", gap: "60px", alignItems: "center", marginBottom: "120px" }}>
          <div style={{ order: 1 }}>
            <h2 style={{ fontSize: "2.8rem", fontWeight: "800", marginBottom: "25px" }}>
              What is <span style={{ color: "#00d4ff" }}>Digital X?</span>
            </h2>
            <p style={{ color: "#8b949e", lineHeight: "1.9", fontSize: "1.1rem" }}>
              At Digital X, we believe in the power of collective knowledge and collaboration to achieve exponentially stronger outcomes. 
              We act as a gateway to uncovering abilities, providing opportunities for students and professionals to interact, 
              solve problems, and contribute to the tech sector.
              <br /><br />
              Based on our strategic delivery model, we connect high-quality engineering talent from India with enterprise 
              requirements in the Middle East, ensuring a seamless flow of innovation and execution.
            </p>
          </div>
          <div style={{ order: 2 }}>
             <img 
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1000&q=80" 
              alt="Digital X Team Collaboration" 
              style={{ width: "100%", borderRadius: "32px", border: "1px solid rgba(255,255,255,0.1)", boxShadow: "0 20px 40px rgba(0,0,0,0.4)" }}
            />
          </div>
        </div>

        {/* ================= MISSION, VISION, VALUES (BROCHURE ACCURATE) ================= */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "30px", marginBottom: "120px" }}>
          <div style={glass}>
            <div style={{ fontSize: "2rem", marginBottom: "20px" }}>🎯</div>
            <h3 style={{ color: "#00d4ff", marginBottom: "15px", textTransform: "uppercase", fontSize: "1rem", letterSpacing: "2px" }}>Mission</h3>
            <p style={{ color: "#8b949e", fontSize: "0.95rem", lineHeight: "1.8" }}>
              To be a trusted and valued partner, delivering the best products and strategic vision to build 
              organizations that attract, develop, and retain talent globally.
            </p>
          </div>
          <div style={glass}>
            <div style={{ fontSize: "2rem", marginBottom: "20px" }}>👁️</div>
            <h3 style={{ color: "#00d4ff", marginBottom: "15px", textTransform: "uppercase", fontSize: "1rem", letterSpacing: "2px" }}>Vision</h3>
            <p style={{ color: "#8b949e", fontSize: "0.95rem", lineHeight: "1.8" }}>
              To create a rich and welcoming environment where everyone can interact, collaborate, and contribute 
              to the tech sector regardless of their level of expertise.
            </p>
          </div>
          <div style={glass}>
            <div style={{ fontSize: "2rem", marginBottom: "20px" }}>⚖️</div>
            <h3 style={{ color: "#00d4ff", marginBottom: "15px", textTransform: "uppercase", fontSize: "1rem", letterSpacing: "2px" }}>Value</h3>
            <p style={{ color: "#8b949e", fontSize: "0.95rem", lineHeight: "1.8" }}>
              We act with complete honesty and transparency. We are self-driven, passionate, and competent 
              in achieving organizational goals through open communication.
            </p>
          </div>
        </div>

        {/* ================= TEAM SECTION ================= */}
        <div style={{ marginBottom: "140px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "3rem", fontWeight: "900" }}>Leadership <span style={{ color: "#00d4ff" }}>Team</span></h2>
            <p style={{ color: "#8b949e" }}>The minds driving technical excellence at Digital X.</p>
          </div>
          
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "40px", justifyContent: "center" }}>
            {/* SHAVEZ QURESHI */}
            <div style={{ textAlign: "center" }}>
              <div style={{ marginBottom: "20px", position: "relative", display: "inline-block" }}>
                <img 
                  src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&h=400&q=80" 
                  alt="Shavez Qureshi" 
                  style={{ width: "220px", height: "220px", borderRadius: "50%", objectFit: "cover", border: "4px solid #00d4ff", padding: "5px" }} 
                />
              </div>
              <h4 style={{ fontSize: "1.4rem", margin: "10px 0 5px" }}>Shavez Qureshi</h4>
              <p style={{ color: "#00d4ff", fontWeight: "700", textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "1px" }}>CEO & Founder</p>
            </div>

            {/* ASHOK P. */}
            <div style={{ textAlign: "center" }}>
              <div style={{ marginBottom: "20px", position: "relative", display: "inline-block" }}>
                <img 
                  src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=400&h=400&q=80" 
                  alt="Ashok P." 
                  style={{ width: "220px", height: "220px", borderRadius: "50%", objectFit: "cover", border: "4px solid rgba(255,255,255,0.1)", padding: "5px" }} 
                />
              </div>
              <h4 style={{ fontSize: "1.4rem", margin: "10px 0 5px" }}>Ashok P.</h4>
              <p style={{ color: "#8b949e", fontWeight: "700", textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "1px" }}>Chief Technology Officer</p>
            </div>
          </div>
        </div>

        {/* ================= CORE STRENGTHS (PROCESS) ================= */}
        
        <div style={{ ...glass, textAlign: "center", padding: "60px", marginBottom: "140px", background: "linear-gradient(rgba(0, 212, 255, 0.05), transparent)" }}>
            <h2 style={{ marginBottom: "20px" }}>Why Partner With Us?</h2>
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "40px", marginTop: "40px" }}>
                <div>
                    <h3 style={{ color: "#00d4ff", margin: 0 }}>Global</h3>
                    <p style={{ color: "#8b949e", fontSize: "0.9rem" }}>Delivery Hubs</p>
                </div>
                <div style={{ width: "1px", height: "50px", background: "rgba(255,255,255,0.1)" }}></div>
                <div>
                    <h3 style={{ color: "#00d4ff", margin: 0 }}>Elite</h3>
                    <p style={{ color: "#8b949e", fontSize: "0.9rem" }}>Resource Pool</p>
                </div>
                <div style={{ width: "1px", height: "50px", background: "rgba(255,255,255,0.1)" }}></div>
                <div>
                    <h3 style={{ color: "#00d4ff", margin: 0 }}>Agile</h3>
                    <p style={{ color: "#8b949e", fontSize: "0.9rem" }}>Execution</p>
                </div>
            </div>
        </div>

      </section>
    </div>
  );
};

export default About;